// // // import React, { useState, useEffect } from "react";
// // // import {
// // //   Box,
// // //   Button,
// // //   Card,
// // //   CardContent,
// // //   Container,
// // //   Typography,
// // //   TextField,
// // //   MenuItem,
// // //   Grid,
// // //   Divider,
// // //   Alert,
// // //   CircularProgress,
// // //   Dialog,
// // //   DialogActions,
// // //   DialogContent,
// // //   DialogContentText,
// // //   DialogTitle,
// // //   Paper,
// // // } from "@mui/material";
// // // import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";
// // // import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
// // // import CategoryIcon from "@mui/icons-material/Category";
// // // import WarningAmberIcon from "@mui/icons-material/WarningAmber";

// // // // आपकी API Functions
// // // import { getAllCategories ,bulkDeleteNews} from "../../../services/adminService"; 
 

// // // const BulkDeleteNews = () => {
// // //   const [categories, setCategories] = useState([]);
// // //   const [formData, setFormData] = useState({
// // //     startDate: "",
// // //     endDate: "",
// // //     categoryId: "",
// // //   });
// // //   const [loading, setLoading] = useState(false);
// // //   const [fetchingCats, setFetchingCats] = useState(false);
// // //   const [openConfirm, setOpenConfirm] = useState(false);
// // //   const [status, setStatus] = useState({ type: "", message: "" });

// // //   // 1. पेज लोड होते ही कैटेगरीज़ लोड करें
// // //   useEffect(() => {
// // //     const fetchCats = async () => {
// // //       try {
// // //         setFetchingCats(true);
// // //         const res = await getAllCategories();
// // //         // डेटा को नाम के हिसाब से सॉर्ट करें (जैसा आपने कैटेगरी मैनेजमेंट में किया था)
// // //         const sorted = (res.data || []).sort((a, b) =>
// // //           a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
// // //         );
// // //         setCategories(sorted);
// // //       } catch (err) {
// // //         console.error("Categories fetch error:", err);
// // //       } finally {
// // //         setFetchingCats(false);
// // //       }
// // //     };
// // //     fetchCats();
// // //   }, []);

// // //   const handleChange = (e) => {
// // //     setFormData({ ...formData, [e.target.name]: e.target.value });
// // //   };

// // //   const handleOpenConfirm = () => {
// // //     if (!formData.startDate || !formData.endDate) {
// // //       setStatus({ type: "error", message: "कृपया शुरू और अंत की तारीख चुनें!" });
// // //       return;
// // //     }
// // //     setOpenConfirm(true);
// // //   };

// // //   const handleProcessDelete = async () => {
// // //     setOpenConfirm(false);
// // //     setLoading(true);
// // //     setStatus({ type: "", message: "" });

// // //     try {
// // //       const result = await bulkDeleteNews(formData);
// // //       setStatus({ 
// // //         type: "success", 
// // //         message: result.message || `${result.deletedCount} न्यूज़ सफलतापूर्वक डिलीट कर दी गईं।` 
// // //       });
// // //       // डिलीट होने के बाद फॉर्म खाली कर दें
// // //       setFormData({ startDate: "", endDate: "", categoryId: "" });
// // //     } catch (error) {
// // //       setStatus({ 
// // //         type: "error", 
// // //         message: error.response?.data?.message || "डिलीट करने में कोई समस्या आई।" 
// // //       });
// // //     } finally {
// // //       setLoading(false);
// // //     }
// // //   };

// // //   return (
// // //     <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
// // //       <Paper elevation={3} sx={{ borderRadius: 2, overflow: "hidden" }}>
// // //         {/* Header Section */}
// // //         <Box sx={{ bgcolor: "#c62828", p: 3, color: "white", display: "flex", alignItems: "center", gap: 2 }}>
// // //           <DeleteSweepIcon fontSize="large" />
// // //           <Box>
// // //             <Typography variant="h5" fontWeight="bold">Bulk Delete News</Typography>
// // //             <Typography variant="body2">तारीख और कैटेगरी के आधार पर न्यूज़ को एक साथ डिलीट करें</Typography>
// // //           </Box>
// // //         </Box>

// // //         <CardContent sx={{ p: 4 }}>
// // //           {status.message && (
// // //             <Alert severity={status.type} sx={{ mb: 3 }} onClose={() => setStatus({ type: "", message: "" })}>
// // //               {status.message}
// // //             </Alert>
// // //           )}

// // //           <Grid container spacing={3}>
// // //             {/* Start Date */}
// // //             <Grid item xs={12} sm={6}>
// // //               <Typography variant="subtitle2" sx={{ mb: 1, display: "flex", alignItems: "center", gap: 1 }}>
// // //                 <CalendarMonthIcon fontSize="small" color="action" /> Start Date
// // //               </Typography>
// // //               <TextField
// // //                 fullWidth
// // //                 type="date"
// // //                 name="startDate"
// // //                 value={formData.startDate}
// // //                 onChange={handleChange}
// // //                 InputLabelProps={{ shrink: true }}
// // //               />
// // //             </Grid>

// // //             {/* End Date */}
// // //             <Grid item xs={12} sm={6}>
// // //               <Typography variant="subtitle2" sx={{ mb: 1, display: "flex", alignItems: "center", gap: 1 }}>
// // //                 <CalendarMonthIcon fontSize="small" color="action" /> End Date
// // //               </Typography>
// // //               <TextField
// // //                 fullWidth
// // //                 type="date"
// // //                 name="endDate"
// // //                 value={formData.endDate}
// // //                 onChange={handleChange}
// // //                 InputLabelProps={{ shrink: true }}
// // //               />
// // //             </Grid>

// // //             {/* Category Select */}
// // //             <Grid item xs={12}>
// // //               <Typography variant="subtitle2" sx={{ mb: 1, display: "flex", alignItems: "center", gap: 1 }}>
// // //                 <CategoryIcon fontSize="small" color="action" /> Category (Optional)
// // //               </Typography>
// // //               <TextField
// // //                 select
// // //                 fullWidth
// // //                 name="categoryId"
// // //                 value={formData.categoryId}
// // //                 onChange={handleChange}
// // //                 disabled={fetchingCats}
// // //                 placeholder="Select Category"
// // //               >
// // //                 <MenuItem value="">
// // //                   <em>-- All Categories (सारी न्यूज़ डिलीट करें) --</em>
// // //                 </MenuItem>
// // //                 {categories.map((cat) => (
// // //                   <MenuItem key={cat._id} value={cat._id}>
// // //                     {cat.name}
// // //                   </MenuItem>
// // //                 ))}
// // //               </TextField>
// // //               {fetchingCats && <Typography variant="caption">कैटेगरी लोड हो रही हैं...</Typography>}
// // //             </Grid>

// // //             <Grid item xs={12}>
// // //               <Box sx={{ mt: 2, p: 2, bgcolor: "#fff5f5", borderRadius: 1, border: "1px dashed #ffcdd2" }}>
// // //                 <Typography variant="body2" color="error" sx={{ display: "flex", alignItems: "center", gap: 1 }}>
// // //                   <WarningAmberIcon fontSize="small" />
// // //                   <strong>सावधानी:</strong> डिलीट की गई न्यूज़ और उनकी मीडिया फाइल्स (Images/Videos) को वापस नहीं लाया जा सकेगा।
// // //                 </Typography>
// // //               </Box>
// // //             </Grid>

// // //             <Grid item xs={12}>
// // //               <Divider sx={{ my: 1 }} />
// // //               <Button
// // //                 fullWidth
// // //                 variant="contained"
// // //                 color="error"
// // //                 size="large"
// // //                 startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <DeleteSweepIcon />}
// // //                 onClick={handleOpenConfirm}
// // //                 disabled={loading}
// // //                 sx={{ py: 1.5, fontWeight: "bold", fontSize: "1rem", boxShadow: 3 }}
// // //               >
// // //                 {loading ? "Deleting Data..." : "Permanently Delete News"}
// // //               </Button>
// // //             </Grid>
// // //           </Grid>
// // //         </CardContent>
// // //       </Paper>

// // //       {/* Delete Confirmation Dialog */}
// // //       <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)}>
// // //         <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1, color: "#d32f2f" }}>
// // //           <WarningAmberIcon /> न्यूज़ डिलीट करने की पुष्टि करें
// // //         </DialogTitle>
// // //         <DialogContent>
// // //           <DialogContentText>
// // //             क्या आप वाकई चुनी गई तारीखों के बीच की न्यूज़ डिलीट करना चाहते हैं? 
// // //             यह एक्शन <strong>परमानेंट</strong> है।
// // //           </DialogContentText>
// // //         </DialogContent>
// // //         <DialogActions sx={{ p: 2 }}>
// // //           <Button onClick={() => setOpenConfirm(false)} variant="outlined">कैंसिल</Button>
// // //           <Button onClick={handleProcessDelete} variant="contained" color="error" autoFocus>
// // //             हाँ, डिलीट करें
// // //           </Button>
// // //         </DialogActions>
// // //       </Dialog>
// // //     </Container>
// // //   );
// // // };

// // // export default BulkDeleteNews;

// // import React, { useState, useEffect } from "react";
// // import {
// //   Box,
// //   Button,
// //   CardContent,
// //   Container,
// //   Typography,
// //   TextField,
// //   MenuItem,
// //   Grid,
// //   Divider,
// //   Alert,
// //   CircularProgress,
// //   Dialog,
// //   DialogActions,
// //   DialogContent,
// //   DialogContentText,
// //   DialogTitle,
// //   Paper,
// // } from "@mui/material";

// // import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";
// // import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
// // import CategoryIcon from "@mui/icons-material/Category";
// // import WarningAmberIcon from "@mui/icons-material/WarningAmber";

// // import {
// //   getAllCategories,
// //   bulkDeleteNews,
// //   previewBulkNews,
// // } from "../../../services/adminService";

// // const BulkDeleteNews = () => {

// //   const [categories, setCategories] = useState([]);

// //   const [formData, setFormData] = useState({
// //     startDate: "",
// //     endDate: "",
// //     categoryId: "",
// //   });

// //   const [previewNews, setPreviewNews] = useState([]);
// //   const [previewLoading, setPreviewLoading] = useState(false);

// //   const [loading, setLoading] = useState(false);
// //   const [fetchingCats, setFetchingCats] = useState(false);

// //   const [openConfirm, setOpenConfirm] = useState(false);

// //   const [status, setStatus] = useState({
// //     type: "",
// //     message: "",
// //   });

// //   // CATEGORY LOAD
// //   useEffect(() => {

// //     const fetchCategories = async () => {

// //       try {

// //         setFetchingCats(true);

// //         const res = await getAllCategories();

// //         const sorted = (res.data || []).sort((a, b) =>
// //           a.name.localeCompare(b.name)
// //         );

// //         setCategories(sorted);

// //       } catch (error) {

// //         console.error("Category fetch error", error);

// //       } finally {

// //         setFetchingCats(false);

// //       }

// //     };

// //     fetchCategories();

// //   }, []);

// //   // INPUT CHANGE
// //   const handleChange = (e) => {

// //     setFormData({
// //       ...formData,
// //       [e.target.name]: e.target.value,
// //     });

// //   };

// //   // PREVIEW NEWS
// //   const handlePreview = async () => {

// //     if (!formData.startDate || !formData.endDate) {

// //       setStatus({
// //         type: "error",
// //         message: "Please select start date and end date",
// //       });

// //       return;

// //     }

// //     try {

// //       setPreviewLoading(true);

// //       const res = await previewBulkNews(formData);

// //       setPreviewNews(res.news || []);

// //       setStatus({
// //         type: "success",
// //         message: `${res.news.length} news found`,
// //       });

// //     } catch (error) {

// //       setStatus({
// //         type: "error",
// //         message: error.response?.data?.message || "Preview failed",
// //       });

// //     } finally {

// //       setPreviewLoading(false);

// //     }

// //   };

// //   // OPEN CONFIRM
// //   const handleOpenConfirm = () => {

// //     if (previewNews.length === 0) {

// //       setStatus({
// //         type: "error",
// //         message: "Please preview news first",
// //       });

// //       return;

// //     }

// //     setOpenConfirm(true);

// //   };

// //   // DELETE NEWS
// //   const handleProcessDelete = async () => {

// //     setOpenConfirm(false);

// //     setLoading(true);

// //     try {

// //       const res = await bulkDeleteNews(formData);

// //       setStatus({
// //         type: "success",
// //         message: res.message,
// //       });

// //       setPreviewNews([]);

// //       setFormData({
// //         startDate: "",
// //         endDate: "",
// //         categoryId: "",
// //       });

// //     } catch (error) {

// //       setStatus({
// //         type: "error",
// //         message: error.response?.data?.message || "Delete failed",
// //       });

// //     } finally {

// //       setLoading(false);

// //     }

// //   };

// //   return (
// //     <Container maxWidth="md" sx={{ mt: 4 }}>

// //       <Paper elevation={3}>

// //         {/* HEADER */}

// //         <Box
// //           sx={{
// //             bgcolor: "#c62828",
// //             color: "white",
// //             p: 3,
// //             display: "flex",
// //             alignItems: "center",
// //             gap: 2,
// //           }}
// //         >

// //           <DeleteSweepIcon fontSize="large" />

// //           <Box>

// //             <Typography variant="h5">
// //               Bulk Delete News
// //             </Typography>

// //             <Typography variant="body2">
// //               Delete news by date range
// //             </Typography>

// //           </Box>

// //         </Box>

// //         <CardContent sx={{ p: 4 }}>

// //           {/* STATUS */}

// //           {status.message && (

// //             <Alert
// //               severity={status.type}
// //               sx={{ mb: 3 }}
// //               onClose={() => setStatus({ type: "", message: "" })}
// //             >

// //               {status.message}

// //             </Alert>

// //           )}

// //           <Grid container spacing={3}>

// //             {/* START DATE */}

// //             <Grid item xs={12} sm={6}>

// //               <Typography
// //                 variant="subtitle2"
// //                 sx={{ mb: 1, display: "flex", gap: 1 }}
// //               >

// //                 <CalendarMonthIcon fontSize="small" />
// //                 Start Date

// //               </Typography>

// //               <TextField
// //                 fullWidth
// //                 type="date"
// //                 name="startDate"
// //                 value={formData.startDate}
// //                 onChange={handleChange}
// //               />

// //             </Grid>

// //             {/* END DATE */}

// //             <Grid item xs={12} sm={6}>

// //               <Typography
// //                 variant="subtitle2"
// //                 sx={{ mb: 1, display: "flex", gap: 1 }}
// //               >

// //                 <CalendarMonthIcon fontSize="small" />
// //                 End Date

// //               </Typography>

// //               <TextField
// //                 fullWidth
// //                 type="date"
// //                 name="endDate"
// //                 value={formData.endDate}
// //                 onChange={handleChange}
// //               />

// //             </Grid>

// //             {/* CATEGORY */}

// //             <Grid item xs={12}>

// //               <Typography
// //                 variant="subtitle2"
// //                 sx={{ mb: 1, display: "flex", gap: 1 }}
// //               >

// //                 <CategoryIcon fontSize="small" />
// //                 Category (Optional)

// //               </Typography>

// //               <TextField
// //                 select
// //                 fullWidth
// //                 name="categoryId"
// //                 value={formData.categoryId}
// //                 onChange={handleChange}
// //                 disabled={fetchingCats}
// //               >

// //                 <MenuItem value="">
// //                   All Categories
// //                 </MenuItem>

// //                 {categories.map((cat) => (

// //                   <MenuItem key={cat._id} value={cat._id}>
// //                     {cat.name}
// //                   </MenuItem>

// //                 ))}

// //               </TextField>

// //             </Grid>

// //             {/* PREVIEW BUTTON */}

// //             <Grid item xs={12}>

// //               <Button
// //                 fullWidth
// //                 variant="outlined"
// //                 onClick={handlePreview}
// //               >

// //                 Preview News

// //               </Button>

// //             </Grid>

// //             {/* PREVIEW LOADER */}

// //             {previewLoading && (

// //               <Grid item xs={12}>

// //                 <Box textAlign="center">

// //                   <CircularProgress />

// //                 </Box>

// //               </Grid>

// //             )}

// //             {/* PREVIEW LIST */}

// //             {previewNews.length > 0 && (

// //               <Grid item xs={12}>

// //                 <Paper sx={{ p: 2, maxHeight: 300, overflow: "auto" }}>

// //                   <Typography variant="h6">
// //                     Total News Found : {previewNews.length}
// //                   </Typography>

// //                   <Divider sx={{ my: 1 }} />

// //                  {previewNews.map((news, index) => (

// //   <Box
// //     key={news._id}
// //     sx={{
// //       display: "flex",
// //       alignItems: "center",
// //       gap: 2,
// //       mb: 2,
// //       borderBottom: "1px solid #eee",
// //       pb: 1
// //     }}
// //   >

// //     {/* IMAGE */}

// //     {news.mediaUrl && (
// //       <Box
// //         component="img"
// //         src={news.mediaUrl}
// //         alt="news"
// //         sx={{
// //           width: 80,
// //           height: 60,
// //           objectFit: "cover",
// //           borderRadius: 1
// //         }}
// //       />
// //     )}

// //     {/* TITLE */}

// //     <Box>

// //      <Typography
// //   fontWeight="bold"
// //   dangerouslySetInnerHTML={{
// //     __html: news.title_en || news.title_hi
// //   }}
// // />

// //       <Typography variant="caption" color="text.secondary">

// //         {new Date(news.createdAt).toLocaleDateString()}

// //       </Typography>

// //     </Box>

// //   </Box>

// // ))}

// //                 </Paper>

// //               </Grid>

// //             )}

// //             {/* DELETE BUTTON */}

// //             <Grid item xs={12}>

// //               <Divider sx={{ my: 2 }} />

// //               <Button
// //                 fullWidth
// //                 variant="contained"
// //                 color="error"
// //                 size="large"
// //                 startIcon={
// //                   loading
// //                     ? <CircularProgress size={20} />
// //                     : <DeleteSweepIcon />
// //                 }
// //                 onClick={handleOpenConfirm}
// //               >

// //                 Permanently Delete News

// //               </Button>

// //             </Grid>

// //           </Grid>

// //         </CardContent>

// //       </Paper>

// //       {/* CONFIRM DIALOG */}

// //       <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)}>

// //         <DialogTitle sx={{ color: "#d32f2f" }}>
// //           Confirm Delete
// //         </DialogTitle>

// //         <DialogContent>

// //           <DialogContentText>

// //             Are you sure you want to delete these news?
// //             This action cannot be undone.

// //           </DialogContentText>

// //         </DialogContent>

// //         <DialogActions>

// //           <Button onClick={() => setOpenConfirm(false)}>
// //             Cancel
// //           </Button>

// //           <Button
// //             onClick={handleProcessDelete}
// //             variant="contained"
// //             color="error"
// //           >

// //             Delete

// //           </Button>

// //         </DialogActions>

// //       </Dialog>

// //     </Container>
// //   );

// // };

// // export default BulkDeleteNews;

// import React, { useState, useEffect } from "react";
// import {
//   Box, Button, CardContent, Container, Typography, TextField,
//   MenuItem, Grid, Divider, Alert, CircularProgress, Dialog,
//   DialogActions, DialogContent, DialogContentText, DialogTitle,
//   Paper, Checkbox, FormControlLabel
// } from "@mui/material";
// import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";
// import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
// import CategoryIcon from "@mui/icons-material/Category";

// import { getAllCategories, bulkDeleteNews, previewBulkNews } from "../../../services/adminService";

// const BulkDeleteNews = () => {
//   const [categories, setCategories] = useState([]);
//   const [formData, setFormData] = useState({ startDate: "", endDate: "", categoryId: "" });
//   const [previewNews, setPreviewNews] = useState([]);
//   const [selectedIds, setSelectedIds] = useState([]); // Selected news IDs
//   const [previewLoading, setPreviewLoading] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [fetchingCats, setFetchingCats] = useState(false);
//   const [openConfirm, setOpenConfirm] = useState(false);
//   const [status, setStatus] = useState({ type: "", message: "" });

//   useEffect(() => {
//     const fetchCategories = async () => {
//       try {
//         setFetchingCats(true);
//         const res = await getAllCategories();
//         setCategories((res.data || []).sort((a, b) => a.name.localeCompare(b.name)));
//       } catch (error) { console.error("Category fetch error", error); }
//       finally { setFetchingCats(false); }
//     };
//     fetchCategories();
//   }, []);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handlePreview = async () => {
//     if (!formData.startDate || !formData.endDate) {
//       setStatus({ type: "error", message: "Please select start date and end date" });
//       return;
//     }
//     try {
//       setPreviewLoading(true);
//       const res = await previewBulkNews(formData);
//       setPreviewNews(res.news || []);
//       setSelectedIds([]); // Reset selection on new preview
//       setStatus({ type: "success", message: `${res.news.length} news found` });
//     } catch (error) {
//       setStatus({ type: "error", message: error.response?.data?.message || "Preview failed" });
//     } finally { setPreviewLoading(false); }
//   };

//   // CHECKBOX LOGIC
//   const handleSelectOne = (id) => {
//     setSelectedIds(prev => 
//       prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
//     );
//   };

//   const handleSelectAll = () => {
//     if (selectedIds.length === previewNews.length) {
//       setSelectedIds([]);
//     } else {
//       setSelectedIds(previewNews.map(n => n._id));
//     }
//   };

//   const handleOpenConfirm = () => {
//     if (previewNews.length === 0) {
//       setStatus({ type: "error", message: "Please preview news first" });
//       return;
//     }
//     setOpenConfirm(true);
//   };

//   const handleProcessDelete = async () => {
//     setOpenConfirm(false);
//     setLoading(true);
//     try {
//       // Agar specific select kiye hain toh IDs bhejo, warna pura filter bhejo
//       const payload = { 
//         ...formData, 
//         ids: selectedIds.length > 0 ? selectedIds : null 
//       };

//       const res = await bulkDeleteNews(payload);
//       setStatus({ type: "success", message: res.message });
//       setPreviewNews([]);
//       setSelectedIds([]);
//       setFormData({ startDate: "", endDate: "", categoryId: "" });
//     } catch (error) {
//       setStatus({ type: "error", message: error.response?.data?.message || "Delete failed" });
//     } finally { setLoading(false); }
//   };

//   return (
//     <Container maxWidth="md" sx={{ mt: 4 }}>
//       <Paper elevation={3}>
//         <Box sx={{ bgcolor: "#c62828", color: "white", p: 3, display: "flex", alignItems: "center", gap: 2 }}>
//           <DeleteSweepIcon fontSize="large" />
//           <Box>
//             <Typography variant="h5">Bulk Delete News</Typography>
//             <Typography variant="body2">Select news and delete them permanently</Typography>
//           </Box>
//         </Box>

//         <CardContent sx={{ p: 4 }}>
//           {status.message && (
//             <Alert severity={status.type} sx={{ mb: 3 }} onClose={() => setStatus({ type: "", message: "" })}>
//               {status.message}
//             </Alert>
//           )}

//           <Grid container spacing={3}>
//             <Grid item xs={12} sm={6}>
//               <Typography variant="subtitle2" sx={{ mb: 1, display: "flex", gap: 1 }}><CalendarMonthIcon fontSize="small" /> Start Date</Typography>
//               <TextField fullWidth type="date" name="startDate" value={formData.startDate} onChange={handleChange} InputLabelProps={{ shrink: true }} />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <Typography variant="subtitle2" sx={{ mb: 1, display: "flex", gap: 1 }}><CalendarMonthIcon fontSize="small" /> End Date</Typography>
//               <TextField fullWidth type="date" name="endDate" value={formData.endDate} onChange={handleChange} InputLabelProps={{ shrink: true }} />
//             </Grid>
//             <Grid item xs={12}>
//               <Typography variant="subtitle2" sx={{ mb: 1, display: "flex", gap: 1 }}><CategoryIcon fontSize="small" /> Category (Optional)</Typography>
//               <TextField select fullWidth name="categoryId" value={formData.categoryId} onChange={handleChange} disabled={fetchingCats}>
//                 <MenuItem value="">All Categories</MenuItem>
//                 {categories.map((cat) => <MenuItem key={cat._id} value={cat._id}>{cat.name}</MenuItem>)}
//               </TextField>
//             </Grid>
//             <Grid item xs={12}>
//               <Button fullWidth variant="outlined" onClick={handlePreview} disabled={previewLoading}>Preview News</Button>
//             </Grid>

//             {previewLoading && <Grid item xs={12} textAlign="center"><CircularProgress /></Grid>}

//             {previewNews.length > 0 && (
//               <Grid item xs={12}>
//                 <Paper sx={{ p: 2, maxHeight: 400, overflow: "auto", border: '1px solid #ddd' }}>
//                   <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
//                     <Typography variant="h6">Found: {previewNews.length}</Typography>
//                     <FormControlLabel
//                       control={<Checkbox checked={selectedIds.length === previewNews.length && previewNews.length > 0} onChange={handleSelectAll} color="primary" />}
//                       label="Select All"
//                     />
//                   </Box>
//                   <Divider sx={{ my: 1 }} />
//                   {previewNews.map((news) => (
//                     <Box key={news._id} sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1, borderBottom: "1px solid #eee", pb: 1 }}>
//                       <Checkbox checked={selectedIds.includes(news._id)} onChange={() => handleSelectOne(news._id)} />
//                       {news.mediaUrl && <Box component="img" src={news.mediaUrl} sx={{ width: 50, height: 40, objectFit: "cover", borderRadius: 1 }} />}
//                       <Box sx={{ flex: 1 }}>
//                         <Typography variant="body2" fontWeight="bold" noWrap dangerouslySetInnerHTML={{ __html: news.title_en || news.title_hi }} />
//                         <Typography variant="caption" color="text.secondary">{new Date(news.createdAt).toLocaleDateString()}</Typography>
//                       </Box>
//                     </Box>
//                   ))}
//                 </Paper>
//                 <Typography variant="caption" color="primary" sx={{ mt: 1, display: 'block' }}>
//                   {selectedIds.length} items selected. (If none selected, ALL items in range will be deleted).
//                 </Typography>
//               </Grid>
//             )}

//             <Grid item xs={12}>
//               <Button
//                 fullWidth variant="contained" color="error" size="large"
//                 startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <DeleteSweepIcon />}
//                 onClick={handleOpenConfirm}
//               >
//                 {selectedIds.length > 0 ? `Delete Selected (${selectedIds.length})` : "Delete All in Range"}
//               </Button>
//             </Grid>
//           </Grid>
//         </CardContent>
//       </Paper>

//       <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)}>
//         <DialogTitle sx={{ color: "#d32f2f" }}>Confirm Permanent Delete</DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//             {selectedIds.length > 0 
//               ? `Are you sure you want to delete only the ${selectedIds.length} selected items?` 
//               : `Are you sure you want to delete ALL ${previewNews.length} items found in this range?`}
//             This action cannot be undone.
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenConfirm(false)}>Cancel</Button>
//           <Button onClick={handleProcessDelete} variant="contained" color="error">Confirm Delete</Button>
//         </DialogActions>
//       </Dialog>
//     </Container>
//   );
// };

// export default BulkDeleteNews;


import React, { useState, useEffect } from "react";
import {
  Box, Button, CardContent, Container, Typography, TextField,
  MenuItem, Grid, Divider, Alert, CircularProgress, Dialog,
  DialogActions, DialogContent, DialogContentText, DialogTitle,
  Paper, Checkbox, FormControlLabel, Chip, Avatar, Tooltip,
  LinearProgress, Fade, Zoom
} from "@mui/material";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CategoryIcon from "@mui/icons-material/Category";
import PreviewIcon from "@mui/icons-material/Preview";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import SelectAllIcon from "@mui/icons-material/SelectAll";
import DeselectIcon from "@mui/icons-material/Deselect";
import ArticleIcon from "@mui/icons-material/Article";

import { getAllCategories, bulkDeleteNews, previewBulkNews } from "../../../services/adminService";

const BulkDeleteNews = () => {
  const [categories, setCategories] = useState([]);
  const [formData, setFormData] = useState({ startDate: "", endDate: "", categoryId: "" });
  const [previewNews, setPreviewNews] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fetchingCats, setFetchingCats] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [status, setStatus] = useState({ type: "", message: "" });

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setFetchingCats(true);
        const res = await getAllCategories();
        setCategories((res.data || []).sort((a, b) => a.name.localeCompare(b.name)));
      } catch (error) { console.error("Category fetch error", error); }
      finally { setFetchingCats(false); }
    };
    fetchCategories();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handlePreview = async () => {
    if (!formData.startDate || !formData.endDate) {
      setStatus({ type: "error", message: "Please select start date and end date." });
      return;
    }
    try {
      setPreviewLoading(true);
      setPreviewNews([]);
      const res = await previewBulkNews(formData);
      setPreviewNews(res.news || []);
      setSelectedIds([]);
      setStatus({ type: "success", message: `${res.news.length} news articles found in this range.` });
    } catch (error) {
      setStatus({ type: "error", message: error.response?.data?.message || "Preview failed. Try again." });
    } finally { setPreviewLoading(false); }
  };

  const handleSelectOne = (id) => {
    setSelectedIds(prev =>
      prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
    );
  };

  const handleSelectAll = () => {
    if (selectedIds.length === previewNews.length) {
      setSelectedIds([]);
    } else {
      setSelectedIds(previewNews.map(n => n._id));
    }
  };

  const handleOpenConfirm = () => {
    if (previewNews.length === 0) {
      setStatus({ type: "error", message: "Please preview news first before deleting." });
      return;
    }
    setOpenConfirm(true);
  };

  const handleProcessDelete = async () => {
    setOpenConfirm(false);
    setLoading(true);
    try {
      const payload = {
        ...formData,
        ids: selectedIds.length > 0 ? selectedIds : null
      };
      const res = await bulkDeleteNews(payload);
      setStatus({ type: "success", message: res.message });
      setPreviewNews([]);
      setSelectedIds([]);
      setFormData({ startDate: "", endDate: "", categoryId: "" });
    } catch (error) {
      setStatus({ type: "error", message: error.response?.data?.message || "Delete failed. Please try again." });
    } finally { setLoading(false); }
  };

  const allSelected = selectedIds.length === previewNews.length && previewNews.length > 0;
  const someSelected = selectedIds.length > 0 && !allSelected;
  const deleteCount = selectedIds.length > 0 ? selectedIds.length : previewNews.length;

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 6 }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@600;700;800&family=DM+Sans:wght@300;400;500&display=swap');

        .bulk-delete-root * { font-family: 'DM Sans', sans-serif; }
        .bulk-delete-root h5, .bulk-delete-root h6 { font-family: 'Syne', sans-serif !important; }

        .news-item-row {
          transition: background 0.18s, transform 0.15s;
          border-radius: 10px;
          padding: 8px 10px;
        }
        .news-item-row:hover {
          background: rgba(198, 40, 40, 0.07);
          transform: translateX(3px);
        }
        .news-item-row.selected-row {
          background: rgba(198, 40, 40, 0.12);
          border-left: 3px solid #c62828;
        }
        .preview-btn {
          transition: all 0.2s !important;
          letter-spacing: 0.5px !important;
        }
        .preview-btn:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 18px rgba(198,40,40,0.2) !important;
        }
        .delete-btn {
          transition: all 0.2s !important;
          letter-spacing: 0.5px !important;
        }
        .delete-btn:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 6px 24px rgba(198,40,40,0.4) !important;
        }
        @keyframes pulseRed {
          0% { box-shadow: 0 0 0 0 rgba(198,40,40,0.3); }
          70% { box-shadow: 0 0 0 10px rgba(198,40,40,0); }
          100% { box-shadow: 0 0 0 0 rgba(198,40,40,0); }
        }
        .pulse-icon { animation: pulseRed 2s infinite; }
      `}</style>

      <Box className="bulk-delete-root">
        {/* HEADER */}
        <Paper
          elevation={0}
          sx={{
            borderRadius: "16px 16px 0 0",
            overflow: "hidden",
            background: "linear-gradient(135deg, #b71c1c 0%, #c62828 50%, #d32f2f 100%)",
            position: "relative",
          }}
        >
          {/* Decorative circles */}
          <Box sx={{
            position: "absolute", top: -30, right: -30, width: 120, height: 120,
            borderRadius: "50%", background: "rgba(255,255,255,0.07)"
          }} />
          <Box sx={{
            position: "absolute", bottom: -20, right: 80, width: 80, height: 80,
            borderRadius: "50%", background: "rgba(255,255,255,0.05)"
          }} />

          <Box sx={{ p: "28px 32px", display: "flex", alignItems: "center", gap: 2.5, position: "relative", zIndex: 1 }}>
            <Box
              className="pulse-icon"
              sx={{
                width: 56, height: 56, borderRadius: "14px",
                background: "rgba(255,255,255,0.15)",
                display: "flex", alignItems: "center", justifyContent: "center",
                backdropFilter: "blur(6px)",
                border: "1px solid rgba(255,255,255,0.2)"
              }}
            >
              <DeleteSweepIcon sx={{ fontSize: 30, color: "white" }} />
            </Box>
            <Box>
              <Typography variant="h5" fontWeight={800} color="white" sx={{ fontFamily: "'Syne', sans-serif !important", lineHeight: 1.2 }}>
                Bulk Delete News
              </Typography>
              <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.75)", mt: 0.4 }}>
                Filter, preview & permanently delete news articles
              </Typography>
            </Box>
            {previewNews.length > 0 && (
              <Chip
                label={`${previewNews.length} found`}
                sx={{
                  ml: "auto", background: "rgba(255,255,255,0.2)", color: "white",
                  fontWeight: 700, fontSize: 13, backdropFilter: "blur(4px)",
                  border: "1px solid rgba(255,255,255,0.3)"
                }}
              />
            )}
          </Box>
        </Paper>

        {/* BODY */}
        <Paper
          elevation={4}
          sx={{
            borderRadius: "0 0 16px 16px",
            border: "1px solid #f0f0f0",
            borderTop: "none",
          }}
        >
          {/* Status Alert */}
          {status.message && (
            <Fade in>
              <Alert
                severity={status.type}
                onClose={() => setStatus({ type: "", message: "" })}
                icon={status.type === "success" ? <CheckCircleOutlineIcon /> : <WarningAmberIcon />}
                sx={{
                  mx: 3, mt: 3, borderRadius: "10px",
                  fontWeight: 500,
                }}
              >
                {status.message}
              </Alert>
            </Fade>
          )}

          <CardContent sx={{ p: "28px 32px" }}>

            {/* STEP 1: FILTER */}
            <Box sx={{ mb: 3 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2.5 }}>
                <Box sx={{
                  width: 28, height: 28, borderRadius: "8px",
                  background: "#c62828", color: "white",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontSize: 13, fontWeight: 800
                }}>1</Box>
                <Typography variant="h6" fontWeight={700} sx={{ color: "#1a1a1a", fontSize: 16 }}>
                  Set Filters
                </Typography>
              </Box>

              <Grid container spacing={2.5}>
                <Grid item xs={12} sm={6}>
                  <Typography variant="caption" sx={{
                    display: "flex", alignItems: "center", gap: 0.7,
                    color: "#555", fontWeight: 600, mb: 0.8, textTransform: "uppercase", letterSpacing: 0.6
                  }}>
                    <CalendarMonthIcon sx={{ fontSize: 15, color: "#c62828" }} /> Start Date
                  </Typography>
                  <TextField
                    fullWidth type="date" name="startDate"
                    value={formData.startDate} onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "10px",
                        "&:hover fieldset": { borderColor: "#c62828" },
                        "&.Mui-focused fieldset": { borderColor: "#c62828" },
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="caption" sx={{
                    display: "flex", alignItems: "center", gap: 0.7,
                    color: "#555", fontWeight: 600, mb: 0.8, textTransform: "uppercase", letterSpacing: 0.6
                  }}>
                    <CalendarMonthIcon sx={{ fontSize: 15, color: "#c62828" }} /> End Date
                  </Typography>
                  <TextField
                    fullWidth type="date" name="endDate"
                    value={formData.endDate} onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "10px",
                        "&:hover fieldset": { borderColor: "#c62828" },
                        "&.Mui-focused fieldset": { borderColor: "#c62828" },
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="caption" sx={{
                    display: "flex", alignItems: "center", gap: 0.7,
                    color: "#555", fontWeight: 600, mb: 0.8, textTransform: "uppercase", letterSpacing: 0.6
                  }}>
                    <CategoryIcon sx={{ fontSize: 15, color: "#c62828" }} /> Category
                    <Chip label="Optional" size="small" sx={{ fontSize: 10, height: 18, ml: 0.5, bgcolor: "#f5f5f5" }} />
                  </Typography>
                  <TextField
                    select fullWidth name="categoryId"
                    value={formData.categoryId} onChange={handleChange}
                    disabled={fetchingCats}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "10px",
                        "&:hover fieldset": { borderColor: "#c62828" },
                        "&.Mui-focused fieldset": { borderColor: "#c62828" },
                      }
                    }}
                  >
                    <MenuItem value="">🗂 All Categories</MenuItem>
                    {categories.map((cat) => (
                      <MenuItem key={cat._id} value={cat._id}>{cat.name}</MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </Grid>
            </Box>

            {/* PREVIEW BUTTON */}
            <Button
              fullWidth className="preview-btn"
              variant="outlined"
              size="large"
              onClick={handlePreview}
              disabled={previewLoading}
              startIcon={previewLoading ? <CircularProgress size={18} color="inherit" /> : <PreviewIcon />}
              sx={{
                borderRadius: "10px", py: 1.4, mb: 3,
                borderColor: "#c62828", color: "#c62828", fontWeight: 700,
                fontSize: 15,
                "&:hover": { borderColor: "#b71c1c", bgcolor: "rgba(198,40,40,0.05)" },
              }}
            >
              {previewLoading ? "Fetching News..." : "Preview News"}
            </Button>

            {previewLoading && (
              <LinearProgress color="error" sx={{ borderRadius: 4, mb: 3, height: 4 }} />
            )}

            {/* STEP 2: SELECT */}
            {previewNews.length > 0 && (
              <Zoom in>
                <Box sx={{ mb: 3 }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
                    <Box sx={{
                      width: 28, height: 28, borderRadius: "8px",
                      background: "#c62828", color: "white",
                      display: "flex", alignItems: "center", justifyContent: "center",
                      fontSize: 13, fontWeight: 800
                    }}>2</Box>
                    <Typography variant="h6" fontWeight={700} sx={{ color: "#1a1a1a", fontSize: 16 }}>
                      Select Articles to Delete
                    </Typography>
                  </Box>

                  <Paper
                    variant="outlined"
                    sx={{ borderRadius: "12px", border: "1px solid #e8e8e8", overflow: "hidden" }}
                  >
                    {/* SELECT ALL BAR */}
                    <Box sx={{
                      display: "flex", justifyContent: "space-between", alignItems: "center",
                      px: 2, py: 1.5,
                      background: "linear-gradient(90deg, #fff5f5 0%, #fff 100%)",
                      borderBottom: "1px solid #f0e0e0"
                    }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={allSelected}
                            indeterminate={someSelected}
                            onChange={handleSelectAll}
                            sx={{
                              color: "#c62828",
                              "&.Mui-checked, &.MuiCheckbox-indeterminate": { color: "#c62828" }
                            }}
                          />
                        }
                        label={
                          <Typography variant="body2" fontWeight={700} color="#333">
                            {allSelected ? "Deselect All" : "Select All"}
                          </Typography>
                        }
                      />
                      <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                        <Chip
                          size="small"
                          label={`${selectedIds.length} / ${previewNews.length} selected`}
                          sx={{
                            background: selectedIds.length > 0 ? "#c62828" : "#eeeeee",
                            color: selectedIds.length > 0 ? "white" : "#555",
                            fontWeight: 600, fontSize: 12
                          }}
                        />
                      </Box>
                    </Box>

                    {/* NEWS LIST */}
                    <Box sx={{ maxHeight: 380, overflow: "auto", p: 1.5 }}>
                      {previewNews.map((news) => (
                        <Box
                          key={news._id}
                          className={`news-item-row ${selectedIds.includes(news._id) ? "selected-row" : ""}`}
                          sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 0.5, cursor: "pointer" }}
                          onClick={() => handleSelectOne(news._id)}
                        >
                          <Checkbox
                            checked={selectedIds.includes(news._id)}
                            onChange={() => handleSelectOne(news._id)}
                            onClick={(e) => e.stopPropagation()}
                            size="small"
                            sx={{
                              p: 0.5,
                              color: "#ccc",
                              "&.Mui-checked": { color: "#c62828" }
                            }}
                          />
                          {news.mediaUrl ? (
                            <Box
                              component="img"
                              src={news.mediaUrl}
                              sx={{ width: 52, height: 42, objectFit: "cover", borderRadius: "8px", flexShrink: 0 }}
                            />
                          ) : (
                            <Box sx={{
                              width: 52, height: 42, borderRadius: "8px",
                              background: "#f5f5f5", display: "flex",
                              alignItems: "center", justifyContent: "center", flexShrink: 0
                            }}>
                              <ArticleIcon sx={{ fontSize: 22, color: "#bbb" }} />
                            </Box>
                          )}
                          <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Typography
                              variant="body2" fontWeight={600}
                              noWrap sx={{ color: "#1a1a1a", fontSize: 13 }}
                              dangerouslySetInnerHTML={{ __html: news.title_en || news.title_hi }}
                            />
                            <Typography variant="caption" color="text.secondary" sx={{ fontSize: 11 }}>
                              📅 {new Date(news.createdAt).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}
                            </Typography>
                          </Box>
                        </Box>
                      ))}
                    </Box>
                  </Paper>

                  {/* HINT */}
                  <Box sx={{
                    display: "flex", alignItems: "center", gap: 1, mt: 1.5,
                    p: "10px 14px", borderRadius: "8px",
                    background: selectedIds.length > 0 ? "#fff3e0" : "#fce4ec",
                    border: `1px solid ${selectedIds.length > 0 ? "#ffb74d" : "#ef9a9a"}`,
                  }}>
                    <WarningAmberIcon sx={{ fontSize: 17, color: selectedIds.length > 0 ? "#e65100" : "#c62828" }} />
                    <Typography variant="caption" fontWeight={600} sx={{ color: selectedIds.length > 0 ? "#e65100" : "#c62828" }}>
                      {selectedIds.length > 0
                        ? `Only ${selectedIds.length} selected article(s) will be deleted.`
                        : `No selection made — ALL ${previewNews.length} articles in this range will be deleted.`}
                    </Typography>
                  </Box>
                </Box>
              </Zoom>
            )}

            {/* STEP 3: DELETE */}
            {previewNews.length > 0 && (
              <Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
                  <Box sx={{
                    width: 28, height: 28, borderRadius: "8px",
                    background: "#c62828", color: "white",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: 13, fontWeight: 800
                  }}>3</Box>
                  <Typography variant="h6" fontWeight={700} sx={{ color: "#1a1a1a", fontSize: 16 }}>
                    Confirm & Delete
                  </Typography>
                </Box>

                <Button
                  fullWidth className="delete-btn"
                  variant="contained"
                  size="large"
                  onClick={handleOpenConfirm}
                  disabled={loading}
                  startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <DeleteSweepIcon />}
                  sx={{
                    borderRadius: "12px", py: 1.6,
                    background: "linear-gradient(135deg, #c62828, #b71c1c)",
                    fontWeight: 800, fontSize: 15, letterSpacing: 0.5,
                    boxShadow: "0 4px 16px rgba(198,40,40,0.3)",
                    "&:hover": {
                      background: "linear-gradient(135deg, #d32f2f, #c62828)",
                    },
                    "&:disabled": { background: "#ccc" }
                  }}
                >
                  {loading ? "Deleting..." : `Delete ${selectedIds.length > 0 ? `Selected (${selectedIds.length})` : `All (${previewNews.length})`}`}
                </Button>
              </Box>
            )}
          </CardContent>
        </Paper>
      </Box>

      {/* CONFIRM DIALOG */}
      <Dialog
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        PaperProps={{ sx: { borderRadius: "16px", overflow: "hidden", maxWidth: 420 } }}
      >
        <Box sx={{
          background: "linear-gradient(135deg, #b71c1c, #c62828)",
          p: "20px 24px", display: "flex", alignItems: "center", gap: 2
        }}>
          <Box sx={{
            width: 44, height: 44, borderRadius: "12px",
            background: "rgba(255,255,255,0.15)",
            display: "flex", alignItems: "center", justifyContent: "center"
          }}>
            <WarningAmberIcon sx={{ color: "white", fontSize: 26 }} />
          </Box>
          <Box>
            <Typography variant="h6" fontWeight={800} color="white" sx={{ fontSize: 17 }}>
              Permanent Delete
            </Typography>
            <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.75)" }}>
              This action cannot be undone
            </Typography>
          </Box>
        </Box>

        <DialogContent sx={{ pt: 3, pb: 1, px: 3 }}>
          <Box sx={{
            p: 2, borderRadius: "10px",
            background: "#fff5f5", border: "1px solid #ffcdd2", mb: 2
          }}>
            <Typography variant="body1" fontWeight={700} color="#c62828" textAlign="center" sx={{ fontSize: 28 }}>
              {deleteCount}
            </Typography>
            <Typography variant="caption" color="#777" textAlign="center" display="block">
              articles will be permanently deleted
            </Typography>
          </Box>
          <DialogContentText sx={{ fontSize: 14, color: "#555" }}>
            {selectedIds.length > 0
              ? `You have selected ${selectedIds.length} specific article(s) for deletion.`
              : `No specific selection — all ${previewNews.length} articles in the selected range will be deleted.`}
          </DialogContentText>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 3, pt: 1, gap: 1.5 }}>
          <Button
            onClick={() => setOpenConfirm(false)}
            variant="outlined"
            fullWidth
            sx={{ borderRadius: "10px", py: 1.1, fontWeight: 600, borderColor: "#ddd", color: "#555" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleProcessDelete}
            variant="contained"
            color="error"
            fullWidth
            sx={{
              borderRadius: "10px", py: 1.1, fontWeight: 700,
              background: "linear-gradient(135deg, #c62828, #b71c1c)",
              boxShadow: "0 4px 14px rgba(198,40,40,0.3)"
            }}
          >
            Yes, Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default BulkDeleteNews;  